// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ConfirmationModal from "../ConfirmationModal.bs.js";

function CloseSidebarConfirmationModal(Props) {
  var isOpen = Props.isOpen;
  var onConfirmCb = Props.onConfirmCb;
  var onCancelCb = Props.onCancelCb;
  return React.createElement(ConfirmationModal.make, {
              title: "Unsaved Changes",
              isOpen: isOpen,
              onConfirmCb: onConfirmCb,
              onCancelCb: onCancelCb,
              confirm_button_title: "Leave this Page",
              cancel_button_title: "Stay on this Page",
              children: React.createElement("p", undefined, "You have not submitted the changes and it will be lost if you leave this page. Are you sure you wish to leave this page?")
            });
}

var make = CloseSidebarConfirmationModal;

export {
  make ,
  
}
/* react Not a pure module */
